import moment from "moment";
import { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import {
  ApprovedIcon,
  BriefCase,
  IdBadge,
  LoctionRedIcon,
  NoticeCalendarIcon,
  RejectIcon,
  RightArrow,
} from "../../../assets/images";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import { CircularAvatar, Loader } from "../../commons";
import CustomizedAvatar from "../../commons/CircularAvatar/CustomizedAvatar";
import { ApproveAndRejectRegularizePayloadType } from "../../../commonTypes/thinksToDoTypes";

type AppProps = {
  toggle: any;
  isOpen: boolean;
  data: any;
  loginData: LoginResponseType;
  handleRegularizeFeedBackSubmit: (
    data: ApproveAndRejectRegularizePayloadType
  ) => void;
};

const RegularizeApproveAndRejectModal = ({
  toggle,
  isOpen,
  data,
  loginData,
  handleRegularizeFeedBackSubmit,
}: AppProps) => {
  const newStartTime = moment(
    data?.regularize?.new_start_time
      ? data?.regularize?.new_start_time
      : data?.start_time,
    "hh:mmA"
  );
  const newEndTime = moment(
    data?.regularize?.new_end_time
      ? data?.regularize?.new_end_time
      : data?.end_time,
    "hh:mmA"
  );

  // Calculate the difference in milliseconds
  const newTimeScheduleDiff = newEndTime.diff(newStartTime, "minutes") / 60;
  const [feedback, setFeedback] = useState("");
  const [showCommentBox, setShowCommentBox] = useState<boolean>(false);

  const handleSubmit = (type: string) => {
    const finalData = {
      date: data?.date,
      userId: data?.user_id?.user_id,
      comment: feedback,
      status: type === "approve" ? 3 : 2,
    };
    handleRegularizeFeedBackSubmit(finalData);
  };

  const handleReject = () => {
    setShowCommentBox(!showCommentBox);
  };

  return (
    <>
      {false ? (
        <Loader />
      ) : (
        <Modal
          centered
          isOpen={isOpen}
          toggle={toggle}
          size="lg"
          style={{ minWidth: "1004px" }}
          backdrop="static"
        >
          <ModalHeader toggle={toggle}>
            Attendance Time Update Request
          </ModalHeader>
          <ModalBody className="pl-2 pr-2" style={{ paddingLeft: "40px" }}>
            <div className="d-flex" style={{ justifyContent: "center" }}>
              <div className="pr-2" style={{ width: "58%" }}>
                <div
                  style={{
                    border: "1px solid #BFCBE1",
                    margin: "5px 28px",
                    borderRadius: "3px",
                    padding: "8px 0px",
                    backgroundColor: "#F4F6F8",
                  }}
                >
                  <div className="ml-3 mb-2">
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      Previous Start And End Time
                    </span>
                  </div>
                  <div className="ml-3 col-md-11" style={{ paddingLeft: "0" }}>
                    <table className="thead-light" style={{ width: "100%" }}>
                      {
                        <thead
                          className="text-start"
                          style={{ backgroundColor: "white" }}
                        >
                          <tr
                            className="text-nowrap"
                            style={{
                              color: "#6e7491",
                              fontSize: "14px",
                              backgroundColor: "#F4F6F8",
                            }}
                          >
                            <td>Start Time</td>
                            <td></td>
                            <td>End Time</td>
                            <td>Total Hours</td>
                          </tr>
                        </thead>
                      }
                      <tbody>
                        <>
                          {
                            <tr>
                              <td
                                className="pb-2"
                                style={{
                                  color: "#262a44",
                                  fontWeight: "400",
                                  fontSize: "15px",
                                }}
                              >
                                {
                                  data?.start_time
                                    ?.split(/([0-9]+:[0-9]+)([APMapm]{2})/)
                                    ?.filter(Boolean)[0]
                                }{" "}
                                {data?.start_time
                                  ?.split(/([0-9]+:[0-9]+)([APMapm]{2})/)
                                  .filter(Boolean)[1]
                                  .toUpperCase()}
                              </td>
                              <td className="pb-2 pr-4" style={{ width: "5%" }}>
                                <span>
                                  <img src={RightArrow} />
                                </span>
                              </td>
                              <td
                                className="pb-2"
                                style={{
                                  color: "#262a44",
                                  fontWeight: "400",
                                  fontSize: "15px",
                                }}
                              >
                                {
                                  data?.end_time
                                    ?.split(/([0-9]+:[0-9]+)([APMapm]{2})/)
                                    ?.filter(Boolean)[0]
                                }{" "}
                                {data?.end_time
                                  ?.split(/([0-9]+:[0-9]+)([APMapm]{2})/)
                                  .filter(Boolean)[1]
                                  .toUpperCase()}
                              </td>
                              <td
                                className="pb-2"
                                style={{
                                  color: "#262a44",
                                  fontWeight: "400",
                                  fontSize: "15px",
                                }}
                              >
                                {!!data?.time_difference
                                  ? data?.time_difference?.toFixed(2)
                                  : "0.00"}
                              </td>
                            </tr>
                          }
                        </>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div style={{ paddingLeft: "12px" }}>
                  <div className="ml-3 mt-3">
                    <span
                      className="ml-3"
                      style={{ fontSize: "16px", fontWeight: "500" }}
                    >
                      New Start And End Time
                    </span>
                  </div>
                  <div
                    className="ml-3 col-md-11"
                    style={{ paddingLeft: "15px", marginTop: "10px" }}
                  >
                    <table className="thead-light" style={{ width: "100%" }}>
                      {
                        <thead
                          className="text-start"
                          style={{ backgroundColor: "white" }}
                        >
                          <tr
                            className="text-nowrap"
                            style={{
                              color: "#6e7491",
                              fontSize: "14px",
                            }}
                          >
                            <td>Start Time</td>
                            <td></td>
                            <td>End Time</td>
                            <td>Total Hours</td>
                          </tr>
                        </thead>
                      }
                      <tbody>
                        <>
                          {
                            <tr>
                              <td
                                className="pb-2"
                                style={{
                                  color: "#262a44",
                                  fontWeight: "400",
                                  fontSize: "15px",
                                }}
                              >
                                {
                                  (
                                    data?.regularize?.new_start_time ||
                                    data?.start_time
                                  )
                                    ?.split(/([0-9]+:[0-9]+)([APMapm]{2})/)
                                    ?.filter(Boolean)[0]
                                }{" "}
                                {(
                                  data?.regularize?.new_start_time ||
                                  data?.start_time
                                )
                                  ?.split(/([0-9]+:[0-9]+)([APMapm]{2})/)
                                  .filter(Boolean)[1]
                                  .toUpperCase()}
                              </td>
                              <td className="pb-2 pr-4" style={{ width: "5%" }}>
                                <span>
                                  <img src={RightArrow} />
                                </span>
                              </td>
                              <td
                                className="pb-2"
                                style={{
                                  color: "#262a44",
                                  fontWeight: "400",
                                  fontSize: "15px",
                                }}
                              >
                                {
                                  (
                                    data?.regularize?.new_end_time ||
                                    data?.end_time
                                  )
                                    ?.split(/([0-9]+:[0-9]+)([APMapm]{2})/)
                                    ?.filter(Boolean)[0]
                                }{" "}
                                {(
                                  data?.regularize?.new_end_time ||
                                  data?.end_time
                                )
                                  ?.split(/([0-9]+:[0-9]+)([APMapm]{2})/)
                                  .filter(Boolean)[1]
                                  .toUpperCase()}
                              </td>
                              <td
                                className="pb-2"
                                style={{
                                  color: "#262a44",
                                  fontWeight: "400",
                                  fontSize: "15px",
                                }}
                              >
                                {newTimeScheduleDiff
                                  ? newTimeScheduleDiff?.toFixed(2)
                                  : "0.00"}
                              </td>
                            </tr>
                          }
                        </>
                      </tbody>
                    </table>
                  </div>

                  <div className="ml-3 mt-3 col-md-10">
                    <label>Reason</label>
                    <p>{data?.regularize?.employee_comment}</p>
                  </div>
                </div>
                <div className="ml-3 mb-2" style={{ paddingLeft: "27px" }}>
                  <span style={{ color: "#6e7491" }}>
                    By clicking Approve will update this user’s time request.
                  </span>
                </div>
                <div className="d-flex ml-3" style={{ paddingLeft: "27px" }}>
                  <div
                    className="pr-3"
                    style={{ cursor: "pointer", height: "fit-content" }}
                    onClick={() => {
                      handleSubmit("approve");
                      toggle();
                    }}
                  >
                    <img src={ApprovedIcon} alt="approved-icon" />
                    <span
                      className="ml-2"
                      style={{
                        color: "#dd4433",
                        fontSize: "16px",
                        fontWeight: 500,

                        cursor: "pointer",
                      }}
                    >
                      Approve
                    </span>
                  </div>
                  <div
                    style={{ height: "fit-content", cursor: "pointer" }}
                    onClick={() => {
                      handleReject();
                    }}
                  >
                    <img src={RejectIcon} alt="reject-icon" />
                    <span className="ml-2">Reject</span>
                  </div>
                </div>
                {showCommentBox && (
                  <div
                    className="ml-3 mb-2 mt-3"
                    style={{ paddingLeft: "27px" }}
                  >
                    <label>
                      Add your comment here
                      <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      style={{ width: "94%" }}
                      value={feedback}
                      onChange={(e) => setFeedback(e.target.value)}
                    />
                  </div>
                )}
                {showCommentBox && (
                  <div
                    className="ml-3 mb-3 mt-3"
                    style={{ paddingLeft: "27px" }}
                  >
                    <button
                      onClick={() => {
                        handleSubmit("reject");
                        toggle();
                      }}
                      className="btn btn-primary"
                      disabled={!feedback?.trim()}
                    >
                      Reject with Comment
                    </button>
                  </div>
                )}
              </div>

              <div style={{ width: "38%", marginTop: "-3px" }}>
                <div
                  style={{
                    height: "fit-content",
                    border: "solid 1px #bfcbe1",
                    borderRadius: "5px",
                  }}
                  className="mt-2"
                >
                  <div
                    className="p-3"
                    style={{ fontSize: "13px", fontWeight: 600 }}
                  >
                    Employee Summary
                  </div>
                  <hr className="m-0"></hr>
                  <div className="p-3">
                    <div
                      className="d-flex align-items-center "
                      style={{ gap: "3%" }}
                    >
                      <CustomizedAvatar
                        name={`${data?.user_id?.first_name} ${
                          data?.user_id?.last_name
                            ? data?.user_id?.last_name
                            : ""
                        }`}
                        image={
                          data?.user_id?.profile_pic &&
                          data?.user_id.profile_pic?.file_url
                        }
                        style={{ width: "75px", fontSize: "25px" }}
                      />
                      <div className="ml-2">
                        <p
                          style={{
                            margin: "0px",
                            color: "#262a44",
                            fontWeight: "500",
                            fontSize: "15px",
                          }}
                        >{`${data?.user_id?.first_name} ${
                          data?.user_id?.last_name
                            ? data?.user_id?.last_name
                            : ""
                        }`}</p>
                        <p
                          style={{
                            margin: "0px",
                            fontSize: "13px",
                            color: "#6e7491",
                          }}
                        >
                          {data?.user_id?.job_title}
                        </p>
                        <p
                          style={{
                            margin: "0px",
                            fontSize: "13px",
                            color: "#6e7491",
                          }}
                        >
                          {data?.user_id?.department}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="inside-card-header d-flex w-100 p-3">
                    <div
                      className="feedBack-heading d-flex align-items-center"
                      style={{ width: "50%" }}
                    >
                      <img src={IdBadge} alt="" className="mr-3" />
                      <div>Employee ID</div>
                    </div>

                    <div style={{ width: "50%" }}>
                      {data?.user_id?.employee_id ? (
                        <span className="sent">
                          {data?.user_id?.employee_id}
                        </span>
                      ) : (
                        "NA"
                      )}
                    </div>
                  </div>

                  <div className="inside-card-header d-flex w-100 p-3">
                    <div
                      className="feedBack-heading d-flex align-items-center"
                      style={{ width: "50%" }}
                    >
                      <img src={BriefCase} alt="" className="mr-3" />
                      <div>Reporting To</div>
                    </div>
                    <div style={{ width: "50%" }}>
                      <div className="d-flex align-items-center">
                        <div>
                          <CircularAvatar
                            name={`${loginData?.first_name} ${loginData?.last_name}`}
                            image={
                              loginData?.profile_pic &&
                              loginData.profile_pic?.file_url
                            }
                          />
                        </div>
                        <span className="ml-2">
                          {`${loginData?.first_name} ${loginData?.last_name}`}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="inside-card-header d-flex w-100 p-3">
                    <div
                      className="feedBack-heading d-flex align-items-center"
                      style={{ width: "50%" }}
                    >
                      <img src={NoticeCalendarIcon} alt="" className="mr-3" />
                      <div>Joining Date</div>
                    </div>
                    <div style={{ width: "50%" }}>
                      {data?.user_id?.joining_date
                        ? data?.user_id?.joining_date
                        : "NA"}
                    </div>
                  </div>
                  <div className="inside-card-header d-flex w-100 p-3">
                    <span
                      className="feedBack-heading d-flex align-items-center"
                      style={{ width: "50%" }}
                    >
                      <img src={LoctionRedIcon} alt="" className="mr-3" />
                      <div>Job Location</div>
                    </span>
                    <div style={{ width: "50%" }}>
                      {data?.user_id?.branch_name
                        ? data?.user_id?.branch_name
                        : "NA"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default RegularizeApproveAndRejectModal;
